import gql from 'graphql-tag';

export const CreateParticipantTasksFromTemplates = gql`
  mutation CreateParticipantTasksFromTemplates(
    $organizationId: ID!
    $participantId: ID!
    $request: CreateParticipantTasksFromTemplatesRequest!
  ) {
    createParticipantTasksFromTemplates(
      organizationId: $organizationId
      participantId: $participantId
      request: $request
    ) {
      id
      participantId
      name
      labels {
        id
        name
        color
      }
      dueDate
      requiresDueDate
      completedAt
      createdAt
      updatedAt
      status
    }
  }
`;
